export default {
  parseValue (value) {
    if (value.length === 1) return this.parseOneDigitValue(value)
    if (value.length === 2) return this.parseTwoDigitsValue(value)
    return this.parseBigValue(value)
  },
  parseOneDigitValue (value) {
    return value.replace(/(.*)/, '0,0$1')
  },
  parseTwoDigitsValue (value) {
    return value.replace(/(.*)/, '0,$1')
  },
  parseBigValue (value) {
    let matches = value.match(/([-{1}]?\d+)(\d{2})/)
    let real = matches[1].split('').reverse()
    real = this.punctuateValue(real)
    return real + ',' + matches[2]
  },
  punctuateValue (value) {
    let length = value.length
    if (value.toString().match(/(.-)/)) {
      length -= 1
    }
    let withPunctuation = []
    for (let i = 0; i < length; i++) {
      if (i > 0 && i % 3 === 0) withPunctuation.push('.')
      withPunctuation.push(value[i])
      if (i === length - 1) {
        withPunctuation.push(value[length])
      }
    }
    return withPunctuation.reverse().join('')
  },
  parseViewValue (value) {
    if (!value) return value
    value = this.cleanPunctuation(parseFloat(value))
    return this.parseValue(value)
  },
  cleanPunctuation (value) {
    if (typeof value === 'number') {
      value = this.correctDecimalPlaces(value)
    }
    return value.toString().replace(/^0+|(?!-)\D/g, '')
  },
  correctDecimalPlaces (value) {
    return value.toFixed(2)
  },
  toFloat (value) {
    value = parseFloat(value.toString().replace(/\./g, '').replace(',', '.'))
    if (isNaN(value)) return ''
    return value
  }
}



// WEBPACK FOOTER //
// ./src/utils/money.js